/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import { ReactComponent as InfoIcon } from 'Assets/svg/info-icon.svg';
import { ReactComponent as AddingContactsImg } from 'Assets/svg/adding-contacts-img.svg';
import { ReactComponent as RefreshIcon } from 'Assets/svg/refreshing-icon.svg';
import noResultsIcon from 'Assets/png/myLeadsNoLeadsInList.png';
import Pagination from 'Components/common/pagination';
import { CreateNewList } from 'Components/common/createNewList';
import AsyncPurchaseExportMsgPopupComponent from 'Components/common/ExportLeads/asyncExportPopup';
import { LoadingWrapper } from 'Components/common/loadingWrapper';
import { toasterState } from 'Components/common/toaster';
import { SyncPurchaseInfoPopup } from 'Pages/advancedSearch/syncPurchaseInfoPopup';
import { userDetail } from 'Stores/userDetail';
import { cancelPreviousAPI, myLeadsState } from 'Stores/myLeads';
import { freeTrialPopupState } from 'Stores/freeTrialPopupState';
import { Utils } from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
import ListPageHeader from './listPageHeader';
import MiddleSection from './MiddleSection';
import { ContactList } from './searchList/contactList';
import ProcessingMessage from '../processingMessage';
import EnablePopUp from './jobChangesPopUp';
import './listPage.scss';

const totalTextShown = [
  'Contacts in list',
  'Contacts with Job Changes',
  'Contacts with Role Changes',
  'Other Updates',
];

const tabNames = CONSTANTS.MY_LEADS_TABS;

const NoLeadsInThisList = ({ currentTab }) => {
  // eslint-disable-next-line react/style-prop-object
  // const tryLeadBuilder = e => {
  //   props.history.push('/advanced-search/contact');
  // };
  return (
    <div className="contact-list">
      <div className="my-leads-list-placeholder no-list-wrap">
        <div className="contact-list-wrap empty-state">
          {myLeadsState.isPurchaseInProgress && currentTab === 0 && (
            <ProcessingMessage />
          )}
          <div className="no-results-wrap">
            {currentTab === 0 ? (
              !myLeadsState.isPurchaseInProgress ? (
                <>
                  <AddingContactsImg />
                  <div className="no-data-text">
                    No contacts are added to this list. You can start adding
                    contacts <br /> to this list, either from other lists or
                    from <b>Contact Search</b>.
                  </div>
                  <div className="nolist-action-wrap" />
                </>
              ) : null
            ) : (
              <>
                <RefreshIcon />
                <div className="no-data-text">
                  You do not have any updates. But don&apos;t forget to check
                  after sometime
                  <br /> as we are constantly refreshing our data!
                </div>
                <div className="nolist-action-wrap" />
              </>
            )}

            {/* <div className="nolist-action-wrap">
          <div className="contact-action-btn" onClick={e => tryLeadBuilder(e)}>
            Try Lead Builder
          </div>
        </div> */}
          </div>
          {/* <div className='archived-contacts'>
                <ArchivedIcon/>
              <div className='archived-contacts-content'>
                <span className='archived-content-first'>We have archived the older contacts in your list. </span>
                <span className='archived-content-second'>Please write to <span>support@adapt.io</span>, if you want to access the archived contacts</span>
              </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

const ResultSection = observer(props => {
  const {
    contactId,
    setContactId,
    currentTab,
    listId,
    currentListInfo,
  } = props;
  const { LOCATION_PREFERENCE = false } = userDetail.featureFlags;

  if (myLeadsState?.leadsResults?.length > 0)
    return (
      <ContactList
        data={myLeadsState.leadsResults}
        currentTab={currentTab}
        allChecked={myLeadsState.allContactSelected}
        contactId={contactId}
        listId={listId}
        setContactId={setContactId}
        pageName="myleads"
        LOCATION_PREFERENCE={LOCATION_PREFERENCE}
        currentListInfo={currentListInfo}
      />
    );

  return <NoLeadsInThisList {...props} currentTab={currentTab} />;
});

const ListPage = observer(props => {
  const { location, history } = props;
  const { id = null } = useParams();
  const currentList = userDetail.myLeadList.find(list => list.id === id);
  const jobUpdateAvailable = currentList ? currentList.jobCount > 0 : false;
  const trigger = Utils.getProspectorUserTrigger(window.location.href);
  const apExportType = Utils.getQueryParamFromUrl(
    'apExportType',
    window.location.href,
  );
  const searchParams = new URLSearchParams(location.search);
  const currentTab = parseInt(
    ['1', '2', '3'].includes(searchParams.get('tab'))
      ? searchParams.get('tab')
      : 0,
    10,
  );
  if (apExportType) freeTrialPopupState.setDynamicText(apExportType);

  const [jobChangePopUp, setJobChangePopUp] = useState(false);
  const [contactId, setContactId] = useState('');
  const [pagination, setPagination] = useState({ page: 1, limit: 50 });
  const [dayFilter, setDayFilter] = useState({ role: '', other: '' });

  const setJobChangePopUpFunction = () => {
    setJobChangePopUp(!jobChangePopUp);
  };

  const clearUpgradePopup = event => {
    const eleList = document.getElementsByClassName('show-upgrade-popup');
    if (eleList !== undefined && eleList.length > 0)
      for (let i = 0; i < eleList.length; i += 1)
        eleList[i].classList.remove('show-upgrade-popup');
    const maskEle = document.getElementsByClassName('upgradePopupMask')[0];
    maskEle.classList.remove('showMask');
  };

  const changePage = (pageNo, opr) => {
    const newPage = pageNo + 1;
    setPagination({ ...pagination, page: newPage });
    Utils.mixpanelTrack(CONSTANTS.MX_ML_EVENTS.ML_LIST_PAGE_PAGINATION_CLICK, {
      page: newPage,
      tab: tabNames[currentTab],
    });
    if (currentTab === 0) {
      if (opr === '+') {
        if (myLeadsState.lastContactId && myLeadsState.lastContactUpdateTs)
          myLeadsState.getLeadsResults({
            pageLimit: pagination.limit,
            listId: myLeadsState.selectedList.id,
            pagination: 'next',
            lastContactId: myLeadsState.lastContactId,
            lastContactUpdateTs: myLeadsState.lastContactUpdateTs,
          });
      } else if (
        myLeadsState.firstContactId &&
        myLeadsState.firstContactUpdateTs
      ) {
        myLeadsState.getLeadsResults({
          pageLimit: pagination.limit,
          listId: myLeadsState.selectedList.id,
          pagination: 'prev',
          lastContactId: myLeadsState.firstContactId,
          lastContactUpdateTs: myLeadsState.firstContactUpdateTs,
        });
      }
    } else {
      myLeadsState.myLeadsContactsInfo({
        type: currentTab,
        listId: id,
        page: newPage,
        limit: pagination.limit,
      });
    }
  };

  const changePageLimit = val => {
    setPagination({ limit: val, page: 1 });
    if (currentTab === 0)
      myLeadsState.getLeadsResults({
        pageLimit: val,
        listId: myLeadsState.selectedList.id,
      });
    else
      myLeadsState.myLeadsContactsInfo({
        type: currentTab,
        listId: id,
        page: 1,
        limit: val,
      });
  };

  const handleDayFilter = (key, days) => {
    setDayFilter({ ...dayFilter, [key]: days });
    Utils.mixpanelTrack(CONSTANTS.MX_CONTACT_UPDATE_EVENTS.TAB_FILTER_CHANGED, {
      noOfDays: days,
      currentTab: tabNames[currentTab],
    });
    myLeadsState.myLeadsContactsInfo({
      type: currentTab,
      days,
      listId: id,
      page: 1,
      limit: pagination.limit,
    });
  };

  useEffect(() => {
    myLeadsState.currentTab = currentTab;
    if (trigger !== null) {
      freeTrialPopupState.setFreeTrialPrePopup(trigger);
      window.history.replaceState(null, null, location.pathname);
    }
    return () => {
      cancelPreviousAPI();
      setDayFilter({ role: '', other: '' });
    };
  }, []);

  useEffect(() => {
    if (userDetail.myLeadList.length > 0) {
      const listData = userDetail.myLeadList.find(list => list.id === id);
      if (listData !== undefined)
        myLeadsState.setSelectedList({ id: listData.id, name: listData.name });
      else
        toasterState.setToastMsg('List does not exist', 'failure', {
          callback: () => {
            history.push('/my-leads');
          },
        });
    }
  }, [userDetail.myLeadList]);

  useEffect(() => {
    if (userDetail.myLeadListLoaded) {
      const selectedTab = parseInt(
        ['1', '2', '3'].includes(
          new URLSearchParams(location.search).get('tab'),
        )
          ? new URLSearchParams(location.search).get('tab')
          : 0,
        10,
      );

      // reset values on tab change
      setPagination({ page: 1, count: 50 });
      setContactId('');
      myLeadsState.leadsResultCount = 0;

      myLeadsState.currentTab = selectedTab;

      if ([1, 2, 3].includes(selectedTab)) {
        if (selectedTab === 1 && !userDetail.isJobChangesEnabled) {
          setJobChangePopUp(true);
          history.push(location.pathname);
        } else {
          let days = null;
          const noOfDays = new URLSearchParams(location.search).get('noOfDays');

          Utils.mixpanelTrack(CONSTANTS.MX_ML_EVENTS.ML_LIST_PAGE_VIEWED, {
            tab: tabNames[selectedTab],
            ...(selectedTab === 2 || selectedTab === 3 ? { noOfDays } : {}),
          });

          if (noOfDays !== null) {
            window.history.replaceState(
              null,
              null,
              `${window.location.href.replace(`&noOfDays=${noOfDays}`, '')}`,
            );
            days = noOfDays;
            if (selectedTab === 2)
              setDayFilter({ ...dayFilter, role: noOfDays });
            if (selectedTab === 3)
              setDayFilter({ ...dayFilter, other: noOfDays });
          } else if ([2, 3].includes(selectedTab)) {
            if (selectedTab === 2 && dayFilter.role) days = dayFilter.role;
            if (selectedTab === 3 && dayFilter.other) days = dayFilter.other;
          }

          myLeadsState.myLeadsContactsInfo({
            type: selectedTab,
            listId: id,
            days,
          });
        }
      } else {
        window.history.replaceState(null, null, location.pathname);
        myLeadsState.getLeadsResults({
          pageLimit: pagination.limit,
          listId: id,
        });
      }
    }
  }, [location, userDetail.myLeadListLoaded]);

  return (
    <div
      className={`my-leads list-page${
        myLeadsState.resultLoading ? ' result-loading' : ''
      }`}
    >
      <div className="upgradePopupMask" onClick={clearUpgradePopup} />
      {!userDetail.isJobChangesEnabled && jobChangePopUp && (
        <EnablePopUp jobChangePopUp popUpFunction={setJobChangePopUpFunction} />
      )}
      <LoadingWrapper show={myLeadsState.actionLoader} position="fixed" />
      <CreateNewList value="leads" />

      <AsyncPurchaseExportMsgPopupComponent />
      <SyncPurchaseInfoPopup />
      <ListPageHeader list={currentList} {...props} />
      <div className="right-section">
        <MiddleSection
          {...props}
          handleDayFilter={handleDayFilter}
          listData={currentList}
          dayFilter={dayFilter}
          pageLimit={pagination.limit}
          currentTab={currentTab}
          jobUpdateAvailable={jobUpdateAvailable}
          popUpFunction={setJobChangePopUpFunction}
        />

        {myLeadsState.resultLoading || !userDetail.myLeadListLoaded ? (
          <ContactList
            isListLoading
            data={[]}
            currentTab={currentTab}
            allChecked={false}
            contactId=""
            setContactId={setContactId}
            pageName="myleads"
          />
        ) : (
          <ResultSection
            currentTab={currentTab}
            contactId={contactId}
            listId={id}
            setContactId={setContactId}
            currentListInfo={currentList}
            {...props}
          />
        )}
        {myLeadsState.leadsResultCount > 0 && (
          <Pagination
            totalCount={myLeadsState.leadsResultCount}
            rowsPerPage={pagination.limit}
            currentPage={pagination.page}
            updateCurrentPage={changePage}
            totalText={totalTextShown[currentTab]}
            onRowsPerPageUpdate={changePageLimit}
            rowsPerPageValues={[10, 25, 50, 100].map(data => {
              return { label: data.toString(), value: data };
            })}
          />
        )}
      </div>
    </div>
  );
});

export default ListPage;
